'use client'
import { useEffect } from 'react'
import { createPortal } from 'react-dom'

type ModalProps = {
  isOpen: boolean
  onClose?: () => void
  blur?: boolean
} & React.HTMLAttributes<HTMLDivElement>

export default function Modal({ isOpen, onClose, children, ...props }: ModalProps) {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && onClose) {
        onClose()
      }
    }

    document.addEventListener('keydown', handleEscape)
    return () => document.removeEventListener('keydown', handleEscape)
  }, [onClose])

  if (!isOpen) return null

  return createPortal(
    <div className="fixed inset-0 z-[200]">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-lg" onClick={onClose} />
      <div className="pointer-events-none relative flex h-full items-center justify-center">
        <div className="pointer-events-auto" {...props}>
          {children}
        </div>
      </div>
    </div>,
    document.body
  )
}
